import { render, staticRenderFns } from "./ProfileDropdown.vue?vue&type=template&id=1874e662"
import script from "./ProfileDropdown.vue?vue&type=script&lang=js"
export * from "./ProfileDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProfileDropdown.vue?vue&type=style&index=0&id=1874e662&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports